<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <jhs-free-heading />
        <div class="c-jhs-free-final-confirm-stepnavi">
            <img :src="buildImageUrl('/img/jhs_free/stepnavi_03.png')" alt="STEP3 最終確認"/>
        </div>

        <!-- 申込内容確認 -->
        <section class="l-section">
            <heading-bg title="申込内容の最終確認"/>
            <div class="l-element">
                <p class="m-text-normal">申込み情報の確認をお願いします。</p>
                <list-text>
                    <li class="m-list-text-item">こちらの情報をもとに無料サービスの対象者となるか審査を行います。</li>
                    <li class="m-list-text-item">この審査の結果次第では利用できない可能性があります。</li>
                </list-text>
                <list-text :caution="true">
                    <li class="m-list-text-item">この申込が完了した後すぐに無料サービスが利用開始できるわけではございませんのでご注意ください。</li>
                </list-text>
            </div>

            <!-- 申込者情報 -->
            <heading-horizon text="申込者の情報"/>
            <div class="l-element">
                <profile-table>
                    <tbody>
                        <tr>
                            <th class="m-table-plain-title"><p>お名前</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="is-light">{{ fullName }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th class="m-table-plain-title"><p>生年月日</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="is-light">{{ birthYear }}年{{ birthMonth }}月{{ birthDay }}日</p>
                            </td>
                        </tr>
                        <tr>
                            <th class="m-table-plain-title"><p>メールアドレス</p></th>
                        </tr>
                        <tr>
                            <td class="m-table-plain-content">
                                <p class="is-light">{{ mailAddress }}</p>
                            </td>
                        </tr>
                    </tbody>
                </profile-table>
            </div>

            <div class="l-element is-text-right">
                <div
                    @click="changeDataLink('/update/profile')"
                    class="is-light c-jhs-free-final-confirm-arrow"
                    data-jest="profile-change-link"
                >
                    変更する
                </div>
            </div>

            <!-- 本人確認書類 -->
            <heading-horizon text="本人確認書類" />

            <!-- 画像 -->
            <div v-for="(item, index) in fileCertificateItems" :key="`${index}`">
                <jhs-free-preview-certificate
                    v-if="item.data"
                    :preview-id="item.id"
                    :certificate-file="item.data"
                    @input="setConvertedImg($event, index)"
                />
            </div>

            <div class="l-element is-text-right">
              <div
                  @click="changeDataLink('/update/certificate')"
                  class="is-light c-jhs-free-final-confirm-arrow"
                  data-jest="certificate-change-link"
              >
                  変更する
              </div>
            </div>
        </section>

        <!-- 保護者の同意 -->
        <section class="l-section">
            <heading-bg title="保護者の同意" />
            <div class="l-element">
                <p class="m-text-normal is-primary is-text-center is-text-bold is-mgb0">保護者の同意をもらってね！</p>
            </div>

            <div class="l-element">
                <form-checkbox label="本サービスへの申込について保護者から同意を得ている。" name="check_parents" v-model="isChecked" />
                <p class="m-text-comments is-caution is-mgt4">※保護者がチェックを入れてください</p>
            </div>
        </section>

        <!-- 申し込みボタン -->
        <div class="l-element">
            <p v-if="isSendError" class="m-text-comments is-caution is-mgb8" data-jest="error-text">
                処理中に問題が発生しました。<br>大変お手数ですが、再度<router-link to="/lp" class="m-text-link" data-jest="lp-link">申込ページ</router-link>よりやり直して頂けますようお願い申し上げます。
            </p>
            <btn
                :priority="switchButtonPriority"
                @click="sendProfile()"
                :text="btnText"
                data-jest="btn-apply"
                class="is-mgb8"
            />
            <p v-if="isClickedButton && !isSendError" class="m-text-comments is-caution is-mgb24" data-jest="text-clicked">● 通信に時間がかかる場合があります。そのまま完了までお待ちください。</p>
            <p v-if="!isClickedButton && !isSendError" class="m-text-comments is-caution is-mgb24" data-jest="text-not-clicked">● このボタンをタップすると申込みが完了します。</p>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import ListText from "../../atoms/ListText.vue";
import HeadingHorizon from "../../atoms/HeadingHorizon.vue";
import ProfileTable from "../../atoms/Table.vue"
import FormCheckbox from "../../atoms/FormCheckbox.vue";
import Btn from "../../atoms/Btn.vue";
import {mapGetters} from "vuex";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import JhsFreePreviewCertificate from "../../molecules/JhsFreePreviewCertificate.vue";
import * as jhsFreeAction from "../../../model/action/JhsFreeAction";
import * as dateUtil from "../../../util/DateUtil";
import {getGa4EventLabel} from "../../../util/Ga4EventUtil";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import * as urlUtil from "../../../util/UrlUtil";

export default {
    name: "JhsFreeLastConfirm",
    components: {
        BaseLayout, JhsFreePreviewCertificate,
        FormCheckbox, HeadingHorizon, HeadingBg,
        JhsFreeHeading, ListText, ProfileTable, Btn
    },
    props: {
        /**
         * title
         */
        title: {
            type: String,
            required: true
        },
        /**
         * description
         */
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            isChecked: false,
            fileCertificateItems: [],
            image1: null,
            image2: null,
            isClickedButton: false,
            isSendError: false,
        }
    },
    computed: {
        ...mapGetters({
            familyName: 'JhsFreeStore/familyName',
            givenName: 'JhsFreeStore/givenName',
            birthYear: 'JhsFreeStore/birthYear',
            birthMonth: 'JhsFreeStore/birthMonth',
            birthDay: 'JhsFreeStore/birthDay',
            mailAddress: 'JhsFreeStore/mailAddress',
            fileCertificateSchoolIssuedFront: 'JhsFreeStore/fileCertificateSchoolIssuedFront',
            fileCertificateSchoolIssuedBack: 'JhsFreeStore/fileCertificateSchoolIssuedBack',
            isAppli: 'AccountStoreV2/isAppli'
        }),
        fullName() {
            return this.familyName + this.givenName
        },
        /**
         * API POST用に生年月日をYYYY-MM-DDに組み立てる
         */
        dateOfBirth() {
            const date = new Date(this.birthYear, this.birthMonth -1, this.birthDay);
            return dateUtil.getDateString(date,'YYYY-MM-DD');
        },
        /**
         * ボタンの活性/非活性切り替え
         */
        switchButtonPriority() {
            if(this.isChecked) {
                if(this.isClickedButton) {
                    // ボタンTAP後はボタンを非活性にする
                    return cssPriority.DISABLED
                } else {
                    return cssPriority.PRIMARY
                }
            } else {
                return cssPriority.DISABLED
            }
        },
        /**
         * ボタンTAP後の文言切り替え
         */
        btnText() {
            if(this.isClickedButton) {
                return this.isSendError ? "この内容で申し込む" : "通信中…";
            } else {
                return  "この内容で申し込む";
            }
        }
    },
    mounted() {
        this.setTitleAndDesc();
        this.setFileCertificate();
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        /**
         * プレビュー部分でjpgに変換した画像をformDataに入れられるようにimage1,image2にセットする
         * @param {object} value Fileオブジェクト
         * @param {number} index 最大2枚
         */
        setConvertedImg(value, index) {
            if(index === 0)  {
                this.image1 = value
            } else {
                this.image2 = value
            }
        },
        setFileCertificate() {
            this.fileCertificateItems.push({data: this.fileCertificateSchoolIssuedFront, id: 'schoolIssued_front'})
            if(this.fileCertificateSchoolIssuedBack) {
                this.fileCertificateItems.push({data: this.fileCertificateSchoolIssuedBack, id: 'schoolIssued_back'})
            }
        },
        sendProfile() {
            if(this.isChecked && !this.isClickedButton) {
                this.isClickedButton = true
                jhsFreeAction.postCompletedAuditionApi(this.fullName, this.mailAddress, this.dateOfBirth, this.image1, this.image2, this.isAppli)
                    .then(result => {
                    getGa4EventLabel('FORM_BUTTON', 'JHS_FREE_APPLY')
                    this.$router.push('/completed/audition')
                })
                    .catch(error => {
                        getGa4EventLabel('FORM_BUTTON', 'JHS_FREE_APPLY_ERROR')
                        // 通信エラー時はエラーメッセージを表示する
                        this.isSendError = true;
                    });
            }
        },
        changeDataLink(path) {
            if(path === '/update/profile') {
                getGa4EventLabel('TAP_BUTTON', 'JHS_FREE_UPDATE_PROFILE')
            } else {
                getGa4EventLabel('TAP_BUTTON', 'JHS_FREE_UPDATE_CERTIFICATE')
            }
            const elementIdList = ['school_issued_front', 'school_issued_back']
            elementIdList.forEach(id =>{
                const c = document.getElementById(`canvas_${id}`);
                if(c){
                    c.width = 0;
                    c.height = 0;
                }
            })
            this.$router.push(path)
        },
        buildImageUrl(url)  {
            return urlUtil.imageUrlUtil.buildImageUrl(url)
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:math";
$grid-base: 4.27vw; // 375px幅に対して16px
$grid-consistent: $grid-base * 0.5; // 375px幅に対して8px

.c-jhs-free-final-confirm {
    &-stepnavi {
        margin: 0 auto;
        padding: $grid-consistent 0;
        width: percentage(math.div(236px, 343px));
    }
    &-arrow::after {
        content: " ";
        display: inline-block;
        width: $grid-consistent;
        height: $grid-base;
        background-image: url(/img/jhs_free/arrow_gray.png);
        background-size: contain;
        background-repeat: no-repeat;
        margin: 0 $grid-consistent 0 6px;
        vertical-align: top;
    }
}
</style>
